'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return Array.prototype.includes || implementation;
};



// WEBPACK FOOTER //
// ./node_modules/array-includes/polyfill.js